import { render, staticRenderFns } from "./NavbarTimer.vue?vue&type=template&id=2472c9c0&"
import script from "./NavbarTimer.vue?vue&type=script&lang=js&"
export * from "./NavbarTimer.vue?vue&type=script&lang=js&"
import style0 from "./NavbarTimer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFabTransition,VRow})
